<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select v-if="!user" :model="filterFormModel" attribute="group" class="mr-1" :options="[
                    {value: 'day', text: $t('byDay')},
                    {value: 'user', text: $t('byUser')}
                    ]"></form-select>
            <admin-user-select v-if="!user" class="mr-1" :model="filterFormModel" attribute="user"
                               :place-holder="$t('translator')"></admin-user-select>
            <time-range-picker ref="timeRangePicker" :model="filterFormModel" @input="load" :label="$t('time')"
                               :default-shortcut="6" class="mr-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
            <export :data="data" :label="label" :group="filterFormModel.group" @reload="load"></export>
          </div>
        </div>
        <div class="tile-body mb-4">
          <div class="row">
            <div class="col-4">
              <div class="tile h-100">
                <apexchart :height="350" :options="chartOptions1" :series="chartData1"></apexchart>
              </div>
            </div>
            <div class="col-8">
              <div class="tile h-100">
                <apexchart :height="300" :options="chartOptions2" :series="chartData2"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th rowspan="2"></th>
                <th colspan="3" class="text-center">{{ $t('submit') }}</th>
                <th colspan="3" class="text-center">{{ $t('confirmed') }}</th>
                <th colspan="3" class="text-center">{{ $t('canceled') }}</th>
                <th colspan="3" class="text-center">{{ $t('total') }}</th>
              </tr>
              <tr>
                <th class="text-center">{{ $t('call') }}</th>
                <th class="text-center">{{ $t('duration') }}</th>
                <th class="text-center">{{ $t('billDuration') }}</th>
                <th class="text-center">{{ $t('call') }}</th>
                <th class="text-center">{{ $t('duration') }}</th>
                <th class="text-center">{{ $t('billDuration') }}</th>
                <th class="text-center">{{ $t('call') }}</th>
                <th class="text-center">{{ $t('duration') }}</th>
                <th class="text-center">{{ $t('billDuration') }}</th>
                <th class="text-center">{{ $t('call') }}</th>
                <th class="text-center">{{ $t('duration') }}</th>
                <th class="text-center">{{ $t('billDuration') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-success">
                <td><b class="text-uppercase">{{ $t('total') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ sum.pending | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.pendingDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.pendingBillDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.confirmed | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.confirmedDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.confirmedBillDuration | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ sum.canceled | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.canceledDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.canceledBillDuration | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ sum.total | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.totalDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.totalBillDuration | callDuration }}</span></td>
              </tr>
              <tr class="bg-warning">
                <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                <td class="text-center"><span class="text-blue">{{ avg.pending  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.pendingDuration  | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.pendingBillDuration  | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ avg.confirmed  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.confirmedDuration  | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.confirmedBillDuration  | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ avg.canceled  | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.canceledDuration  | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.canceledBillDuration  | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ avg.total | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.totalDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.totalBillDuration | callDuration }}</span></td>
              </tr>
              <tr :key="index" v-for="(item, index) in data">
                <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                <td class="text-center"><span class="text-blue">{{ item.pending | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.pendingDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.pendingBillDuration | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ item.confirmed | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.confirmedDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.confirmedBillDuration | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ item.canceled | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.canceledDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.canceledBillDuration | callDuration }}</span>
                </td>
                <td class="text-center"><span class="text-blue">{{ item.total | numFormat }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.totalDuration | callDuration }}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.totalBillDuration | callDuration }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from '../../components/TimeRangePicker'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import AdminUserSelect from '@/components/AdminUserSelect.vue'
import Export from '@/views/admin-call/ReportExport.vue'

export default {
  props: ['user'],
  components: { Export, AdminUserSelect, TimeRangePicker, 'apexchart': VueApexCharts },
  data: function() {
    return {
      filterFormModel: {
        group: 'day',
        user: this.user ? this.user._id : null
      },
      loading: true,
      data: [],
      chartOptions1: {
        chart: {
          type: 'donut'
        }
      },
      chartData1: [],
      chartOptions2: {
        chart: {
          type: 'bar'
        }
      },
      chartData2: [],
      sum: 0,
      avg: 0
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show()
      this.loading = true
      if (!this.filterFormModel.to || !this.filterFormModel.from) {
        this.filterFormModel.from = moment().startOf('month').format('x')
        this.filterFormModel.to = moment().endOf('month').format('x')
      }
      this.$service.get('/admin-call/report', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data
        this.sum = {}
        this.avg = {}
        this.data.forEach(item => {
          for (let key in item) {
            item[key] = Math.abs(item[key])
            if (!this.sum[key]) {
              this.sum[key] = 0
            }
            this.sum[key] += Math.abs(item[key])
          }
        })
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length)
        }
        this.chartOptions1 = {
          colors: ['#feb019', '#00e396', '#ff4560'],
          labels: [this.$t('submit'), this.$t('confirmed'), this.$t('canceled')],
          chart: { zoom: { enabled: false }, type: 'donut', toolbar: { show: true } },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    label: new Intl.NumberFormat().format(this.data.reduce((sum, d) => sum + d.total, 0)),
                    formatter: () => {
                      return this.$t('translations')
                    },
                    showAlways: true,
                    show: true
                  },
                  value: {
                    fontSize: '16px'
                  }
                }
              }
            }
          },
          legend: {
            position: 'bottom'
          }
        }
        let totalPending = this.data.reduce((sum, d) => sum + d.pending, 0)
        let totalConfirmed = this.data.reduce((sum, d) => sum + d.confirmed, 0)
        let totalCanceled = this.data.reduce((sum, d) => sum + d.canceled, 0)
        this.chartData1 = [totalPending, totalConfirmed, totalCanceled]
        this.chartOptions2 = {
          colors: ['#feb019', '#00e396', '#ff4560'],
          xaxis: {
            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
            labels: {
              rotate: 0
            },
            tooltip: {
              enabled: false
            }
          },
          yaxis: {
            labels: {
              formatter: function(value) {
                return new Intl.NumberFormat().format(value)
              }
            }
          },
          chart: {
            zoom: {
              enabled: false
            },
            type: 'bar',
            stacked: true
          }
        }
        this.chartData2 = [
          {
            name: this.$t('submit'),
            data: this.data.map(d => d.pending).slice(0, 99).reverse()
          },
          {
            name: this.$t('confirmed'),
            data: this.data.map(d => d.confirmed).slice(0, 99).reverse()
          },
          {
            name: this.$t('canceled'),
            data: this.data.map(d => d.canceled).slice(0, 99).reverse()
          }
        ]
      }).finally(() => {
        loader.hide()
        this.loading = false
      })
    },
    label(item) {
      if (item.label) {
        return item.label
      }
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('DD/MM/YYYY')
      }
    }
  },
  mounted() {
    this.load()
  },
  i18n: {
    messages: {
      en: {
        submit: 'Pending',
        confirmed: 'Confirmed',
        canceled: 'Canceled',
        translations: 'Translation(s)',
        byDay: 'By days',
        byUser: 'By translators',
        translator: 'Translator',
        call: 'Call',
        duration: 'Total duration (s)',
        billDuration: 'Talk duration (s)'
      },
      vi: {
        submit: 'Chờ duyệt',
        confirmed: 'Đã duyệt',
        canceled: 'Từ chối',
        translations: 'Bản dịch',
        byDay: 'Theo ngày',
        byUser: 'Theo người biên dịch',
        translator: 'Người biên dịch',
        call: 'Cuộc gọi',
        duration: 'Thời lượng (s)',
        billDuration: 'Thời gian đàm thoại (s)'
      }
    }
  }
}
</script>
